@import '../../styles/customMediaQueries.css';

.root {
  width: 100%;

  /* Top Bar's drop shadow should always be visible */
  z-index: var(--zIndexTopbar);
  position: fixed;

  @media (--viewportMedium) {
    position: relative;
  }
}

.transparent {
  background: transparent;
}
.transparent::before {
  background-image: linear-gradient(to bottom, #000, rgba(0, 0, 0, 0)) !important;
  content: '' !important;
  height: 140% !important;
  left: 0px !important;
  pointer-events: none !important;
  position: absolute !important;
  top: 0px !important;
  width: 100% !important;
  z-index: -1 !important;
  -webkit-transition: 150ms opacity ease !important;
  -moz-transition: 150ms opacity ease !important;
  transition: 150ms opacity ease !important;
  opacity: 0.4 !important;
}

.fixed {
  @media (--viewportMedium) {
    left: 0;
    right: 0;
    top: 0;
    position: fixed;
    width: auto;
  }
}

.absoluteHeaderOffset {
  padding-top: 60px;

  @media (--viewportMedium) {
    padding-top: 72px;
  }
}

.container {
  /* Size */
  width: 100%;
  height: var(--topbarHeight);

  /* Layout for child components */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;

  /* fill */
  /* background-color: rgb(var(--mpc-color-white-bg)); */

  /* shadows */
  /* box-shadow: var(--boxShadow); */

  @media (--viewportMedium) {
    display: none;
  }
}

.home {
  display: flex;
  padding: calc((var(--topbarHeight) - var(--Topbar_logoHeight)) / 2) 24px;
}

.logoutButton {
  margin: 0;
}

/* Child component's size (and positioning) should be given here */
.menu,
.searchMenu {
  /* Font */
  @apply __marketplaceH5FontStyles;
  color: var(--matterColor);

  /* Layout */
  display: flex;
  margin: 0;
  border-width: 0px;
  background-color: transparent;

  /* Hovers */
  &:enabled {
    cursor: pointer;
  }
  &:enabled:hover,
  &:enabled:active {
    background-color: transparent;
    box-shadow: none;
  }
  &:disabled {
    background-color: transparent;
    cursor: auto;
  }
}

.menu {
  padding: 15px var(--find-play-container-padding);
  position: relative;
}
.searchMenu {
  padding: var(--find-play-container-padding);
}

.menuIcon {
  min-height: 26px;
  min-width: 26px;
}

.searchMenuIcon {
  margin: 9px 0;
}

.notificationDot {
  /* Dimensions */
  width: 12px;
  height: 12px;
  border-radius: 50%;

  /* Position */
  position: absolute;
  top: 17px;
  right: 17px;

  /* Style: red dot with white border */
  background-color: var(--failColor);
  border: 2px solid rgb(var(--mpc-color-white));

  animation-name: notificationPop;
  animation-duration: 0.1s;
  animation-delay: 0.1s;
  animation-fill-mode: forwards;

  animation-timing-function: ease-in;
  opacity: 0;
  transform: scale(0);
}

@keyframes notificationPop {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.desktop {
  display: none;

  @media (--viewportMedium) {
    display: block;
  }
}

/* Icon component styles */
.rootMenuIcon {
  fill: var(--matterColor);
}
.rootSearchIcon {
  stroke: var(--matterColor);
}

.searchContainer {
  position: relative;
  height: 100%;
  margin-top: 94px;
}

.mobileHelp {
  color: var(--matterColorAnti);
  margin: 0 24px;

  /* Absolute position to avoid affecting the layout of the autocomplete
   predictions list */
  position: absolute;
  top: 73px;
}

/* ================ Modal ================ */

.modalContainer {
  @apply __marketplaceModalInMobileBaseStyles;
  padding: 0;

  @media (--viewportMedium) {
    flex-basis: 576px;
  }
}

.missingInformationModal {
  @apply __marketplaceModalBaseStyles;
  padding-top: 70px;
}

/* Title of the modal */
.modalTitle {
  @apply __marketplaceModalTitleStyles;
}

/* Paragraph for the Modal */
.modalMessage {
  @apply __marketplaceModalParagraphStyles;
}

/* Make the email pop */
.email {
  @apply __marketplaceModalHighlightEmail;
}

.helperLink {
  @apply __marketplaceModalHelperLink;
}

.helperText {
  @apply __marketplaceModalHelperText;
}

.error {
  @apply __marketplaceModalErrorStyles;
}

.bottomWrapper {
  @apply __marketplaceModalBottomWrapper;

  /* Align the helper links to the left since there isn't a Primary Button anymore */
  text-align: left;
}

.modalIcon {
  @apply __marketplaceModalIconStyles;
}

.reminderModalLinkButton {
  @apply __marketplaceButtonStylesPrimary;
}

.genericError {
  position: fixed;
  top: calc(var(--topbarHeight) + 15px);

  /* Place enough to the right to hide the error */
  right: -355px;
  opacity: 0;

  max-width: 340px;
  margin: 0 15px;

  /* Animate error from the right */
  transition: all ease-out 0.2s;
  transition-delay: 1s;

  /* Bleed the bg color from the bottom */
  padding-bottom: 4px;
  background-color: var(--marketplaceColor);
  border-radius: 4px;

  /* Place on top of everything */
  z-index: var(--zIndexGenericError);

  @media (--viewportMedium) {
    top: calc(var(--topbarHeightDesktop) + 15px);
  }
}

.genericErrorVisible {
  right: 0;
  opacity: 1;
}

.genericErrorContent {
  padding: 16px 22px;
  border-radius: 4px;
  background-color: var(--marketplaceColorLight);
  border-radius: 4px;
}

.genericErrorText {
  @apply __marketplaceH5FontStyles;
  font-weight: var(--fontWeightSemiBold);
  margin: 0;
  color: rgb(var(--mpc-color-white));

  @media (--viewportMedium) {
    margin: 0;
  }
}
